wbApp.controller('LeadsBindUserAndStudentDetailCtrl', ['$scope', '$translate', '$q', '$modal', 'userSvc', 'studentSvc',
function ($scope, $translate, $q, $modal, userSvc, studentSvc) {

    $scope.model = $scope.inputModel || {};

    $scope.isSaving = false;

    $scope.isInvalid = function (model) {
        return !model || !model.userID || !model.studentID;
    }

    $scope.disableStudentAdd = function (model) {
        return !model || !model.userID;
    }

    $scope.onAddUserClick = function () {
        var userDetail = userSvc.createNew();
        if (!!$scope.notRegisteredUserInfo) {
            userDetail.surname = $scope.notRegisteredUserInfo.surname;
            userDetail.name = $scope.notRegisteredUserInfo.name;
            userDetail.middlename = $scope.notRegisteredUserInfo.middlename;
            userDetail.phone = $scope.notRegisteredUserInfo.phone;
            userDetail.email = $scope.notRegisteredUserInfo.email;
            userDetail.address = $scope.notRegisteredUserInfo.address;
            userDetail.referenceSourceID = $scope.notRegisteredUserInfo.referenceSourceId;
        }

        userDetailDialogPromise.$promise.then(function () {
            userDetailDialogPromise.$scope.userDetail = angular.copy(userDetail);
            userDetailDialogPromise.$scope.preFilled = true;
            userDetailDialogPromise.$scope.userSaved = function (model) {
                $scope.model.userID = model.id;
            },
            userDetailDialogPromise.show();
        });
    }

    $scope.onAddStudentclick = function () {
        var student = studentSvc.createNew();
        student.userID = $scope.model.userID;
        if (!!$scope.notRegisteredUserInfo &&
            !!$scope.notRegisteredUserInfo.students &&
            $scope.notRegisteredUserInfo.students.length > 0) {

            student.name = $scope.notRegisteredUserInfo.students[0].name;
            student.middlename = $scope.notRegisteredUserInfo.students[0].middlename;
            student.surname = $scope.notRegisteredUserInfo.students[0].surname;
            student.birthday = $scope.notRegisteredUserInfo.students[0].birthday;
            student.nationality = $scope.notRegisteredUserInfo.students[0].nationality;
            student.adminNotes = $scope.notRegisteredUserInfo.students[0].health;
        }

        studentDialogPromise.$promise.then(function () {
            studentDialogPromise.$scope.collection = [];
            studentDialogPromise.$scope.model = student;
            studentDialogPromise.$scope.preFilled = true;
            studentDialogPromise.$scope.onStudentSave = function (model) {
                $scope.model.studentID = model.id;                
            };
            studentDialogPromise.show();
        });
    }

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        $scope.onUserAndStudentAssigned($scope.model);
        $scope.$hide();

        $scope.isSaving = false;
    }

    var userDetailDialogPromise = $modal({
        templateUrl: 'users/users-detail.html',
        show: false,
        scope: $scope
    });

    var studentDialogPromise = $modal({
        templateUrl: 'users/students/students-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
